import React, { useState, useEffect } from 'react';
import { notification, Modal, Divider, Skeleton, Typography } from 'antd';
import dayjs from 'dayjs';

import { catchExceptionSRate } from '../../../utils/helpers/helpers';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';

import { post, put, get } from '../../../api/module/resume';

import './style.scss';
import NaturalPersonForm from '../../../containers/NaturalPersonForm';

const { Paragraph } = Typography;

const NaturalPersonForms = ({ history, match, readOnly = false }) => {
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [person_id, setPersonId] = useState(parseInt(match.params.person_id));
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setIsLoading(true);
        await handleGet();
        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);

  const handleGet = async () => {
    try {
      let data = {};
      if (person_id) {
        const response = await get(person_id);
        data = response.data;
        if (data.fecha_expedicion_documento != null) {
          data.fecha_expedicion_documento = dayjs(
            data.fecha_expedicion_documento,
          );
        }
        if (data.fecha_nacimiento != null)
          data.fecha_nacimiento = dayjs(data.fecha_nacimiento);
        data.numeroDocumentoConfirm = data.numero_identificacion;
        data.celularConfirm = data.numero_celular;
        data.correoConfirm = data.notificacion_email;

        if (data['notificacion_pais'] == null) {
          data['notificacion_pais'] = 45;
        }
        if (
          data['notificacion_estado'] == null &&
          data['notificacion_pais'] === 45
        ) {
          data['notificacion_estado'] = 3;
        }
        if (
          data['notificacion_ciudad'] == null &&
          data['notificacion_estado'] === 3
        ) {
          data['notificacion_ciudad'] = 149;
        }
        setInitialValues(data);
      } else {
        if (data['notificacion_pais'] == null) {
          data['notificacion_pais'] = 45;
        }
        if (
          data['notificacion_estado'] == null &&
          data['notificacion_pais'] === 45
        ) {
          data['notificacion_estado'] = 3;
        }
        if (
          data['notificacion_ciudad'] == null &&
          data['notificacion_estado'] === 3
        ) {
          data['notificacion_ciudad'] = 149;
        }

        setInitialValues(data);
      }
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_GET_MSG,
        duration: 2,
      });
    }
  };

  const checkDocs = () => {
    Modal.success({
      title: 'Se ha registrado correctamente su información',
      content: (
        <>
          <Divider />
          <Paragraph>
            Recuerde que puede actualizarla cuando lo considere necesario.
          </Paragraph>
          <Paragraph>
            Gracias por su interés en trabajar con nosotros.
          </Paragraph>
          <Paragraph>
            Tendremos en cuenta la información registrada cuando Corpoeducación
            lo requiera.
          </Paragraph>
          <Paragraph>
            Por favor, revise constantemente la bandeja de entrada,
            notificaciones y correo no deseado (spam) de su correo electrónico.
          </Paragraph>
        </>
      ),
      onOk: () => {
        window.location = '/';
      },
    });
  };

  const save = async (data) => {
    try {
      data.fecha_expedicion_documento = dayjs(
        data.fecha_expedicion_documento,
      ).format('YYYY-MM-DD');
      data.fecha_nacimiento = dayjs(data.fecha_nacimiento).format('YYYY-MM-DD');
      data.tipo_persona = 1;

      if (data.notificacion_pais !== 45) {
        data.notificacion_estado = null;
      }
      if (data.hasOwnProperty('codigo_postal')) {
        if (data['codigo_postal'] === '') {
          delete data['codigo_postal'];
        }
      }

      if (!person_id) {
        setLoading(true);
        const response = await post(data);
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
        setTimeout(() => {
          history.push(`${INTERNAL_LINKS.NATURAL_PERSON}/${response.data.id}`);
          setPersonId(response.data.id);
          setLoading(false);
        }, MESSAGES.TIME);
      } else {
        setLoading(true);
        await put(person_id, data);
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
        setLoading(false);
      }
    } catch (err) {
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_POST_MSG);
      setLoading(false);
    }
  };

  return (
    <Skeleton loading={isLoading} active>
      {initialValues != null && (
        <NaturalPersonForm
          onFinish={save}
          initialValues={initialValues}
          loading={loading}
          personID={parseInt(person_id)}
          readOnly={readOnly}
          checkDocs={checkDocs}
        />
      )}
    </Skeleton>
  );
};

export default NaturalPersonForms;
